const nodes = [
  { name: "India", detail: "Sourcing conversation", left: "76%", top: "48%", testId: "trade-corridor-node-india" },
  { name: "GCC", detail: "Regional market route", left: "56%", top: "27%", testId: "trade-corridor-node-gcc" },
  { name: "Africa", detail: "Buyer market route", left: "39%", top: "68%", testId: "trade-corridor-node-africa" },
  { name: "Global", detail: "Wider opportunities", left: "20%", top: "22%", testId: "trade-corridor-node-global" },
];

export default function TradeCorridorStory() {
  return (
    <section id="trade-corridor" data-testid="ugi-trade-corridor-section" className="border-y border-[#E5DFD3] bg-[#F5F2EB]">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
        <div className="mb-14 grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#C5A059]">Trade Corridor</p>
            <h2 className="mt-5 font-serif text-3xl font-normal leading-tight tracking-[-0.02em] text-[#1C1613] sm:text-4xl">
              A geographic route shaped around the buyer's destination.
            </h2>
          </div>
          <p className="max-w-xl text-base font-light leading-8 text-[#524842] lg:justify-self-end">
            The route begins with a requirement in India and can extend toward GCC, African and wider global markets. Each enquiry remains guided by the product, destination and buyer brief.
          </p>
        </div>

        <div data-testid="trade-corridor-map-container" className="relative min-h-[620px] overflow-hidden border border-[#C5A059]/25 bg-[#FDFBF7] shadow-sm sm:min-h-[560px]">
          <img src="/assets/ugi-nautical-map.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-65 contrast-[1.08] sepia-[0.14]" />
          <div className="absolute inset-0 bg-gradient-to-br from-[#FDFBF7]/40 via-[#F5F2EB]/10 to-[#FDFBF7]/40" />
          <div className="absolute inset-0 opacity-[0.08] map-grid" aria-hidden="true" />

          <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1000 560" fill="none" preserveAspectRatio="none" aria-hidden="true">
            <path d="M760 270C690 208 632 154 560 151C484 149 438 281 390 381C342 335 274 230 200 123" stroke="#1C1613" strokeOpacity="0.14" strokeWidth="18" strokeLinecap="round" />
            <path className="route-path" d="M760 270C690 208 632 154 560 151C484 149 438 281 390 381C342 335 274 230 200 123" stroke="#C5A059" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="10 12" />
            {[
              [760, 270],
              [560, 151],
              [390, 381],
              [200, 123],
            ].map(([cx, cy]) => (
              <g key={`${cx}-${cy}`}>
                <circle className="node-ring" cx={cx} cy={cy} r="22" fill="none" stroke="#C5A059" strokeWidth="1" />
                <circle cx={cx} cy={cy} r="8" fill="#1C1613" stroke="#C5A059" strokeWidth="4" />
              </g>
            ))}
          </svg>

          {nodes.map((node) => (
            <div key={node.name} data-testid={node.testId} className="absolute w-36 -translate-x-1/2 -translate-y-1/2 sm:w-44" style={{ left: node.left, top: node.top }}>
              <div className="border border-[#C5A059]/35 bg-[#FDFBF7]/90 p-4 shadow-lg backdrop-blur-sm">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#1C1613]">{node.name}</p>
                <p className="mt-2 text-[11px] leading-5 text-[#524842]">{node.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
